import { SmartRoofOwesReport, SmartRoofOwesReportItem } from "../../../models";

export const getSmartRoofOwesReport = (data: any): SmartRoofOwesReport => {
  return {
    invoices: data.invoices.map(getSmartRoofOwesReportItem),
  };
};

const getSmartRoofOwesReportItem = (data: any): SmartRoofOwesReportItem => {
  return {
    invoiceId: data.invoice_id,
    orderId: data.order_id,
    name: data.name,
    total: data.total,
    type: data.type,
    date: data.date,
    address: data.address,
  };
};
